import { useGetDocumentQuery } from "@store/services/documents";
import { useGetLawdocsDocumentQuery } from "@store/services/lawdocs";

import { hasLawdocsOwnerNames, resolveDocumentOwnerNames } from "@utils";

import { type IDocument } from "@types";

export const useCartDocument = (documentId: IDocument["id"]) => {
  const { data: document, isLoading: isDocumentLoading } = useGetDocumentQuery(documentId);
  const identifier = document?.identifier ?? undefined;
  const isLawdocsSkipped = document == null || identifier == null || !hasLawdocsOwnerNames(document.type);
  const { data: lawdocs, isLoading: isLawdocsDocumentLoading } = useGetLawdocsDocumentQuery(identifier ?? "", {
    skip: isLawdocsSkipped,
  });

  const enrichedDocument =
    document == null || lawdocs?.document == null
      ? document
      : { ...document, ...resolveDocumentOwnerNames(document.type, lawdocs.document) };

  return { document: enrichedDocument, isLoading: isDocumentLoading || isLawdocsDocumentLoading };
};
